import { useArcadeStoreSKUsForCountry } from '@src/hooks/useQuests';
import { HStack, Skeleton, Text, VStack } from 'ui_2';
import { ProductSkuCard } from './ProductSkuCard';

export const ProductSkuCards = () => {
  const { data, isLoading } = useArcadeStoreSKUsForCountry();

  if (isLoading) {
    return (
      <HStack className='w-full gap-4'>
        <Skeleton className='h-[150px] w-1/2' delay={0} />
        <Skeleton className='h-[150px] w-1/2' delay={1} />
      </HStack>
    );
  }

  if (data?.length === 0) {
    return null;
  }

  return (
    <VStack className='max-w-[100%] gap-2'>
      <Text font='bold-sm'>Reward yourself</Text>
      <HStack className='gap-12 overflow-y-hidden overflow-x-scroll pb-2 pl-8'>
        {data?.map((sku, key) => (
          <ProductSkuCard sku={sku} key={key} />
        ))}
      </HStack>
    </VStack>
  );
};
